module.exports = __webpack_public_path__ + "static/media/paramount-estates.f2bc61f4.pdf";